export const ADIBannerSettings = {
    websiteCode: {
        US: "US",
        CAEN: "CAEN",
        CAFR: "CAFR",
        PR: "PR",
    },
    headerOneLength: 50,
    headerTwoLength: 140,
    copyOneLength: 45,
    copyTwoLength: 70,
    copyThreeLength: 41,
    smallCopyOneLength: 45,
    smallCopyTwoLength: 45,
    buttonTextLength: 20,
};

export const ADIMarketingTyleSettings = {
    websiteCode: {
        US: "US",
        CAEN: "CAEN",
        CAFR: "CAFR",
        PR: "PR",
    },
    statusCode: {
        expired: 1,
        live: 2,
        pending: 3,
    },
    headerLength: 39,
    bodyLength: 46,
    dateLength: 27,
    buttonTextLength: 20,
}
